<template>
  <v-row class="fixed-buttons">
    <v-col class="text-right" cols="12">
      <v-card height="50" rounded v-show="!hideButtons">
        <v-card-actions class="ml-3">
          <div>
            <v-icon @click="hideButtons = !hideButtons" class="grey--text mr-4 iconeEncolhe">mdi-chevron-right</v-icon>
            <v-btn
              @click="salvar()"
              :color="!aguarde ? 'bluePcm' : 'lightGray'"
              dark
              class="mr-4"
              :loading="aguarde"
              :disabled="disableSaveButton"
            >
              Salvar
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached mdi-spin</v-icon>
                </span>
              </template>
            </v-btn>
            <v-btn @click="cancelar" color="darkRed" dark class="mr-4" :disabled="aguarde">Cancelar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <v-card height="30" rounded v-show="hideButtons">
        <v-card-actions>
          <v-icon @click="hideButtons = !hideButtons" class="grey--text icone">mdi-chevron-left</v-icon>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    pararLoader: Object,
    disableSaveButton: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    hideButtons: false,
    aguarde: false,
    loader: null,
  }),

  methods: {
    async salvar() {
      this.aguarde = true
      this.$emit('salvar')
    },
    cancelar() {
      this.$emit('cancelar')
    },
  },

  watch: {
    pararLoader: {
      handler(pararLoader) {
        if (pararLoader.parar) {
          this.aguarde = false
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.fixed-buttons {
  position: fixed;
  right: 0;
  bottom: 0;
  margin-bottom: 30px;
}

.icone {
  margin-top: -5px;
  width: 8px;
}

.iconeEncolhe {
  margin-top: -3px;
}
</style>
